import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Construction } from '@mui/icons-material';

interface ComingSoonProps {
  title?: string;
  subtitle?: string;
  description?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({
  title = 'Coming Soon',
  subtitle,
  description = 'This feature is currently under development and will be available soon.',
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        p: 3,
      }}
    >
      <Card
        sx={{
          maxWidth: 600,
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          borderRadius: 2,
        }}
      >
        <CardContent sx={{ p: 5 }}>
          <Construction
            sx={{
              fontSize: 80,
              color: 'primary.main',
              mb: 3,
              opacity: 0.8,
            }}
          />
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{ fontWeight: 600, color: 'text.primary' }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="h6"
              component="h2"
              gutterBottom
              sx={{ color: 'text.secondary', fontWeight: 400, mb: 2 }}
            >
              {subtitle}
            </Typography>
          )}
          <Typography
            variant="body1"
            sx={{ color: 'text.secondary', lineHeight: 1.8 }}
          >
            {description}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ComingSoon;
